import './OrderItem.scss';
import React from 'react';
import { Card } from 'antd';
import { FormattedDate, FormattedTime } from 'react-intl';

interface IProps {
  isOrderItemVoucher: boolean;
  imageUrl: string;
  name?: string;
  oneLiner?: string;
  date?: Date;
  venue?: string;
  city?: string;
}

const OrderItem: React.SFC<IProps> = ({
  isOrderItemVoucher,
  name,
  oneLiner,
  imageUrl,
  date,
  venue,
  city,
}) => {

  if (!imageUrl) {
    return null;
  }

  const cardCover = (
    <div className='image-container'>
      <img alt={ name } src={ imageUrl } />
    </div>
  );

  if (isOrderItemVoucher) {
    return (
      <Card cover={ cardCover } className='order-item voucher' />
    );
  }

  return (
    <Card cover={ cardCover } className='order-item'>
      { name && <h1>{ name }</h1> }
      { date &&
        <div className='meta'>
          <FormattedDate value={ date } year='numeric' month='long' day='numeric' />,&nbsp;
          <FormattedTime value={ date } />
        </div>
      }
      { city && <div className='meta'>{ `${ venue }, ${ city }` }</div> }
      { oneLiner && <div className='text'>{ oneLiner }</div> }
    </Card>
  );
};

export default OrderItem;


// WEBPACK FOOTER //
// ./src/components/OrderItem/OrderItem.tsx